export const themeConstants = {
    CHANGE: 'THEME_CHANGE',
};